$(document).ready(function(){
  $('.s-faq .accordion .drawer1 .accordion-header').first().trigger('click');
})

$(window).on('load',function(){
  var reviews = $('.yotpo.yotpo-main-widget')
  var bundles = $('.picky-bundler-container.picky-widget')
  var review_heading = $('.product-single h3.review-head')
  
  $(bundles).insertBefore(reviews)
  $(review_heading).prependTo(reviews)
  
  $('a[class^="ComboProductCard_title"]').each(function(){
    
    var that = $(this);
    var product_url = $(this).attr('href')
    
    jQuery.getJSON(product_url + '.js', function(product) {
     
      for (i=0;i<=product.tags.length;i++){
        
        var tag = product.tags[i]
        var combo_tag = tag.substring(0,7)
        
        console.log(combo_tag)
        
        if (combo_tag == 'combo__'){
          console.log('y')
         var text = '<span>' + tag.substring(7) + '</span>'
         console.log(text)
         $(text).insertAfter(that)
        }

      }
      
    });

    
  })

})
